/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as UsersRouteImport } from './pages/users'
import { Route as ProfileRouteImport } from './pages/profile'
import { Route as PendingApprovalsRouteImport } from './pages/pending-approvals'
import { Route as LoginRouteImport } from './pages/login'
import { Route as HomeRouteImport } from './pages/home'
import { Route as EmployeesRouteImport } from './pages/employees'
import { Route as AppSettingsRouteImport } from './pages/app-settings'
import { Route as IndexRouteImport } from './pages/index'
import { Route as ReportsIndexRouteImport } from './pages/reports/index'
import { Route as ProjectsIndexRouteImport } from './pages/projects/index'
import { Route as ProjectsProjectIdRouteImport } from './pages/projects/$projectId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingApprovalsRoute = PendingApprovalsRouteImport.update({
  id: '/pending-approvals',
  path: '/pending-approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesRoute = EmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/app-settings',
  path: '/app-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app-settings': typeof AppSettingsRoute
  '/employees': typeof EmployeesRoute
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/pending-approvals': typeof PendingApprovalsRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects': typeof ProjectsIndexRoute
  '/reports': typeof ReportsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app-settings': typeof AppSettingsRoute
  '/employees': typeof EmployeesRoute
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/pending-approvals': typeof PendingApprovalsRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects': typeof ProjectsIndexRoute
  '/reports': typeof ReportsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app-settings': typeof AppSettingsRoute
  '/employees': typeof EmployeesRoute
  '/home': typeof HomeRoute
  '/login': typeof LoginRoute
  '/pending-approvals': typeof PendingApprovalsRoute
  '/profile': typeof ProfileRoute
  '/users': typeof UsersRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/': typeof ProjectsIndexRoute
  '/reports/': typeof ReportsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app-settings'
    | '/employees'
    | '/home'
    | '/login'
    | '/pending-approvals'
    | '/profile'
    | '/users'
    | '/projects/$projectId'
    | '/projects'
    | '/reports'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app-settings'
    | '/employees'
    | '/home'
    | '/login'
    | '/pending-approvals'
    | '/profile'
    | '/users'
    | '/projects/$projectId'
    | '/projects'
    | '/reports'
  id:
    | '__root__'
    | '/'
    | '/app-settings'
    | '/employees'
    | '/home'
    | '/login'
    | '/pending-approvals'
    | '/profile'
    | '/users'
    | '/projects/$projectId'
    | '/projects/'
    | '/reports/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppSettingsRoute: typeof AppSettingsRoute
  EmployeesRoute: typeof EmployeesRoute
  HomeRoute: typeof HomeRoute
  LoginRoute: typeof LoginRoute
  PendingApprovalsRoute: typeof PendingApprovalsRoute
  ProfileRoute: typeof ProfileRoute
  UsersRoute: typeof UsersRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-approvals': {
      id: '/pending-approvals'
      path: '/pending-approvals'
      fullPath: '/pending-approvals'
      preLoaderRoute: typeof PendingApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees': {
      id: '/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-settings': {
      id: '/app-settings'
      path: '/app-settings'
      fullPath: '/app-settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppSettingsRoute: AppSettingsRoute,
  EmployeesRoute: EmployeesRoute,
  HomeRoute: HomeRoute,
  LoginRoute: LoginRoute,
  PendingApprovalsRoute: PendingApprovalsRoute,
  ProfileRoute: ProfileRoute,
  UsersRoute: UsersRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
